import { styled } from '@mui/material/styles';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

const DesktopDatePickerSC = styled(DesktopDatePicker)(({ theme }) => ({
  '.MuiFormLabel-root': {
    paddingLeft: '8px',
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '120%',
    color: '#8F8F8F',
  },
  '.MuiSvgIcon-root':{
      marginRight: '10px;',
      color: '#2685CA'
  },
  '.MuiFormLabel-root.mui-focused': {
    color: '#2685CA !important'
  },
  '.MuiInput-root:before':{
    borderBottom: '1px solid #E5E5E5'
  },
  '.MuiInputBase-root':{
    // paddingLeft: '10px',
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '120%',
  }
}));
export default DesktopDatePickerSC
